export const PUSH_CENTER_APP_ID_KEY = 'push_center.selected_app_id';
export const PUSH_CENTER_TAB_KEY = 'push_center.active_tab';
export const PUSH_CENTER_TEST_TOKEN_KEY = 'push_center.test_token';

export const getStoredAppId = (): number | null => {
    const raw = localStorage.getItem(PUSH_CENTER_APP_ID_KEY);
    const num = raw ? Number(raw) : NaN;
    return Number.isFinite(num) && num > 0 ? num : null;
};

export const getStoredTestToken = (): string | null =>
    localStorage.getItem(PUSH_CENTER_TEST_TOKEN_KEY);

export const setStoredTestToken = (token: string): void => {
    if (token) {
        localStorage.setItem(PUSH_CENTER_TEST_TOKEN_KEY, token);
    } else {
        localStorage.removeItem(PUSH_CENTER_TEST_TOKEN_KEY);
    }
};